(function() {
  if (!window.theme) return;

  var activeDrawer = null;
  var lastTrigger = null;

  function hydrateRecommendations(form) {
    if (!form || form.dataset.tvSearchHydrated === 'true') return;
    var template = form.querySelector('template[data-search-pre-template]');
    var target = form.querySelector('[data-search-pre-target]');
    if (template && target) {
      target.appendChild(template.content.cloneNode(true));
      target.hidden = false;
    }
    form.dataset.tvSearchHydrated = 'true';
  }

  function updateTriggerState(open) {
    document.querySelectorAll('.searchIcn').forEach(function(trigger) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      trigger.setAttribute('aria-controls', 'SearchDrawer');
    });
  }

  function focusableIn(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href],button:not([disabled]),textarea,input:not([disabled]),select,[tabindex]:not([tabindex="-1"])'
      )
    ).filter(function(el) {
      return !el.hasAttribute('hidden') && el.offsetParent !== null;
    });
  }

  function closeDrawer() {
    if (!activeDrawer) return;
    activeDrawer.setAttribute('aria-hidden', 'true');
    activeDrawer.hidden = true;
    document.documentElement.classList.remove('showOverly', 'stopScroll', 'searchact');
    document.body.classList.remove('showOverly', 'stopScroll', 'searchact');
    updateTriggerState(false);
    var focusTarget = lastTrigger;
    activeDrawer = null;
    if (focusTarget && typeof focusTarget.focus === 'function') {
      focusTarget.focus();
    }
  }

  function openDrawer(trigger) {
    var drawer = document.querySelector('.searchDrawer');
    if (!drawer) return;
    lastTrigger = trigger || document.activeElement;
    activeDrawer = drawer;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('showOverly', 'stopScroll', 'searchact');
    document.body.classList.add('showOverly', 'stopScroll', 'searchact');
    updateTriggerState(true);

    var form = drawer.querySelector('form');
    hydrateRecommendations(form);
    window.setTimeout(function() {
      var input = drawer.querySelector('input[name="q"]');
      if (input) input.focus();
    }, 50);
  }

  function bindDrawerA11y() {
    document.querySelectorAll('.searchIcn').forEach(function(trigger) {
      if (trigger.dataset.tvSearchTriggerBound === 'true') return;
      trigger.dataset.tvSearchTriggerBound = 'true';
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', 'SearchDrawer');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('click', function(event) {
        event.preventDefault();
        openDrawer(trigger);
      });
    });

    document.querySelectorAll('.closeSearch').forEach(function(closeButton) {
      if (closeButton.dataset.tvSearchCloseBound === 'true') return;
      closeButton.dataset.tvSearchCloseBound = 'true';
      closeButton.addEventListener('click', function(event) {
        event.preventDefault();
        closeDrawer();
      });
    });

    document.querySelectorAll('.modalOverly').forEach(function(overlay) {
      if (overlay.dataset.tvSearchOverlayBound === 'true') return;
      overlay.dataset.tvSearchOverlayBound = 'true';
      overlay.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function(event) {
      if (!activeDrawer) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusables = focusableIn(activeDrawer);
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function searchLiveRegion(form) {
    var region = form.querySelector('[data-search-live-region]');
    if (!region) {
      region = document.createElement('div');
      region.className = 'hidden_txt';
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('data-search-live-region', 'true');
      form.appendChild(region);
    }
    return region;
  }

  theme.Search = (function() {
    function init() {
      bindDrawerA11y();
      document.querySelectorAll('form.search').forEach(function(form) {
        if (form.dataset.tvSearchInit === 'true') return;
        form.dataset.tvSearchInit = 'true';

        var input = form.querySelector('input[name="q"]');
        var results = form.querySelector('[data-search-results]');
        var pre = form.querySelector('[data-search-pre]');
        var liveRegion = searchLiveRegion(form);

        if (!input || !results) return;

        var controller = null;
        var render = function() {
          hydrateRecommendations(form);
          var query = input.value.trim();
          if (!query.length) {
            results.innerHTML = '';
            results.hidden = true;
            results.style.display = 'none';
            if (pre) pre.style.display = '';
            liveRegion.textContent = '';
            return;
          }
          if (controller) controller.abort();
          controller = new AbortController();
          var predictiveSearchUrl = window.routes && window.routes.predictive_search_url
            ? window.routes.predictive_search_url
            : '/search/suggest';
          fetch(predictiveSearchUrl + '?q=' + encodeURIComponent(query) + '&section_id=predictive-search', {
            signal: controller.signal
          }).then(function(response) {
            return response.text();
          }).then(function(html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var section = parsed.querySelector('#shopify-section-predictive-search');
            results.innerHTML = section ? section.innerHTML : html;
            results.hidden = false;
            results.style.display = '';
            if (pre) pre.style.display = 'none';
            liveRegion.textContent = query;
          }).catch(function(error) {
            if (error && error.name === 'AbortError') return;
            results.hidden = true;
            results.style.display = 'none';
          });
        };

        // Inline (header) forms open their panel on focus: recommendations while empty, suggestions once typing.
        // It closes on a click outside (theme.js body handler, which covers .main-search) or on Escape.
        var panel = form.closest('.searchDrawer') ? null : form.querySelector('.s_res');
        var openPanel = function() {
          if (panel) panel.style.display = 'block';
        };
        input.addEventListener('focus', function() {
          hydrateRecommendations(form);
          openPanel();
        });
        input.addEventListener('input', openPanel);
        input.addEventListener('keydown', function(event) {
          if (panel && event.key === 'Escape') panel.style.display = 'none';
        });
        input.addEventListener('keyup', render);
        input.addEventListener('change', render);
      });
    }

    return { init: init };
  })();
})();
